import './topbar.css';

export default function Topbar(props) {

    return (
        <div className="topbarContainer">
            <div className="logo">
                Share Now - Share Your Feelings Instantly
            </div>

        </div>
    )
}
